__turbopack_context__.v({
  "cartCheckoutLogin": "cartCheckoutLogin-module-scss-module__B-ZAca__cartCheckoutLogin",
  "cartCheckoutLoginMethod": "cartCheckoutLogin-module-scss-module__B-ZAca__cartCheckoutLoginMethod",
  "cartLoginForm": "cartCheckoutLogin-module-scss-module__B-ZAca__cartLoginForm",
  "cartLoginFormError": "cartCheckoutLogin-module-scss-module__B-ZAca__cartLoginFormError",
  "cartLoginFormFields": "cartCheckoutLogin-module-scss-module__B-ZAca__cartLoginFormFields",
  "cartLoginFormRemember": "cartCheckoutLogin-module-scss-module__B-ZAca__cartLoginFormRemember",
  "checkbox": "cartCheckoutLogin-module-scss-module__B-ZAca__checkbox",
  "customerLogin": "cartCheckoutLogin-module-scss-module__B-ZAca__customerLogin",
});
